module.exports = __webpack_public_path__ + "img/new-loe.6da6371c.svg";